import { css } from 'styled-components'

import EOT from './RawsonPro-MediumIt.eot'
import SVG from './RawsonPro-MediumIt.svg'
import TTF from './RawsonPro-MediumIt.ttf'
import WOFF from './RawsonPro-MediumIt.woff'

const MediumIt = css`
  @font-face {
    font-family: 'Rawson Pro';
    font-style: italic;
    font-weight: 500;
    src: url(${EOT}) format('embedded-opentype'),
      url(${WOFF}) format('woff'), url(${TTF}) format('truetype'),
      url(${SVG}) format('svg');
  }
`

export default MediumIt



// WEBPACK FOOTER //
// ./src/styles/fonts/RawsonPro/MediumIt/index.js